import { Parameters } from '../../backend';

export function parseParamsStr(paramsStr: string): Parameters {
    const bp: Parameters = JSON.parse(paramsStr);
    bp.startDate = new Date(bp.startDate);
    bp.endDate = new Date(bp.endDate);
    return bp;
}
